<style lang="less" scoped>
    .customer{
        display: inline-block;
        vertical-align: top;
        position: relative;
        padding: 10px 29px 10px 217px;
        width: 550px;
        min-height: 202px;
        margin: 8px;
        background: white;
        text-align: left;
        border-radius: 30px;
        &:hover .customer-avatar img{
            transform: scale(1.06);
        }
    }
    .customer-avatar{
        position: absolute;
        top: 10px;
        left: 10px;
        display: inline-block;
        width: 182px;
        height: 182px;
        background: #f5f5f5;
        text-align: center;
        border-radius: 24px;
        overflow: hidden;
    }
    .customer-avatar img{
        width: 100%;
        height: 100%;
        transition: transform .25s ease;
        will-change: transform;
    }
    .customer-content{
        position: relative;
        padding-top: 20px;
    }
    .customer-title{
        margin-bottom: 11px;
        line-height: 1;
    }
    .customer-name{
        font-size: 30px;
        color: black;
    }
    .customer-nickname{
        font-size: 12px;
        color: black;
    }
    .customer-more-poptip{
        float: right;
    }
    .customer-more, .customer-tag{
        display: inline-block;
        padding: 2px 8px;
        border-radius: 5px;
        border: 1px solid #b3b3b3;
        color: #b3b3b3;
        line-height: 14px;
    }
    .customer-tag{
        float: right;
        margin-right: 2px;
        border-color: transparent;
    }
    .customer-more{
        cursor: pointer;
    }
    .custoemr-intro{
        white-space: pre-line;
        font-size: 12px;
        color: #000;
        text-align: justify;
        line-height: 20px;
        background-color: white;
        cursor: pointer;
        transition: .5s;
    }
    .custoemr-intro-folded{
        max-height: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
    }
    .custoemr-intro-expanded{
        max-height: 10000px;
        overflow: auto;
    }
    .expand-tip{
        text-align: right;
        color: #b3b3b3;
        margin-top: 5px;
        cursor: pointer;
    }
    .contact-line{
        position: relative;
        clear: both;
    }
    .contact-item{
        display: inline-block;
        vertical-align: top;
    }
    .contact-label{
        position: absolute;
        left: 0;
        top: 0;
        width: 60px;
        text-align: left;
    }
    .contact-gap{
        position: absolute;
        left: 65px;
        top: 0;
    }
    .contact-value{
        padding-left: 73px;
    }
    .customer-badges{
        position: absolute;
        top: -4px;
        line-height: 1;
    }
    .customer-badge{
        display: inline-block;
        vertical-align: top;
    }
    .badge-image{
        display: inline-block;
        width: 20px;
        cursor: pointer;
    }
    .badge-image:hover{
        box-shadow: 0 1px 3px rgba(55, 55, 55, .3);
    }
    .badge-image-large{
        width: 180px;
    }
    .badge-title{
        /* margin-top: 10px; */
        font-size: 30px;
    }
    .expand-enter-active, .expand-leave-active {
        max-height: 1000px;
    }
    .expand-enter, .expand-leave-to {
        max-height: 0;
    }
</style>
<template>
  <div class="customer">
    <div class="customer-avatar">
      <img
        v-if="customer.candid_photo"
        :src="customer.candid_photo"
      >
      <Icon
        v-else
        type="ios-person"
        size="180"
        color="#dddee1"
      />
    </div>
    <div class="customer-content">
      <div class="customer-badges">
        <div
          v-for="(badge, index) in customer.badges"
          :key="index"
          class="customer-badge"
        >
          <Poptip trigger="hover">
            <div>
              <img
                class="badge-image"
                :src="badge.url"
              >
            </div>
            <div
              slot="content"
              class="text-center"
            >
              <img
                class="badge-image-large"
                :src="badge.url"
              >
              <div class="badge-title">
                {{ badge.badgeTitle }}
              </div>
              <div class="badge-desc">
                {{ badge.badgeDesc }}
              </div>
            </div>
          </Poptip>
        </div>
      </div>
      <div class="customer-title">
        <span class="customer-name">{{ customer.account }}</span>
        <span
          v-if="customer.nickname"
          class="customer-nickname"
        >({{ customer.nickname }})</span>
        <Poptip
          class="customer-more-poptip"
          trigger="hover"
          placement="bottom-end"
        >
          <span class="customer-more">more+</span>
          <div slot="content">
            <div class="contact-line">
              <span class="contact-item contact-label">性别</span>
              <span class="contact-item contact-gap">:</span>
              <span class="contact-item contact-value">
                <span>{{ customer.gender ? '男' : '女' }}</span>
              </span>
            </div>
            <div class="contact-line">
              <span class="contact-item contact-label">
                <span>团队</span>
                <span>/</span>
                <span>岗位</span>
              </span>
              <span class="contact-item contact-gap">:</span>
              <span class="contact-item contact-value">
                <span v-if="customer.team">{{ customer.team }}</span>
                <span
                  v-else
                  class="color-grey"
                >未填写</span>
                <span>/</span>
                <span v-if="customer.job">{{ customer.job }}</span>
                <span
                  v-else
                  class="color-grey"
                >未填写</span>
              </span>
            </div>
            <div class="contact-line">
              <span class="contact-item contact-label">邮箱</span>
              <span class="contact-item contact-gap">:</span>
              <span class="contact-item contact-value">
                <span v-if="customer.email">{{ customer.email }}</span>
                <span
                  v-else
                  class="color-grey"
                >未填写</span>
              </span>
            </div>
            <div class="contact-line">
              <span class="contact-item contact-label">手机</span>
              <span class="contact-item contact-gap">:</span>
              <span class="contact-item contact-value">
                <span v-if="customer.mobile">{{ customer.mobile }}</span>
                <span
                  v-else
                  class="color-grey"
                >未填写</span>
              </span>
            </div>
            <div class="contact-line">
              <span class="contact-item contact-label">
                <span>微信</span>
                <span>/</span>
                <span>QQ</span>
              </span>
              <span class="contact-item contact-gap">:</span>
              <span class="contact-item contact-value">
                <span v-if="customer.wechat_number">{{ customer.wechat_number }}</span>
                <span
                  v-else
                  class="color-grey"
                >未填写</span>
                <span>/</span>
                <span v-if="customer.qq_number">{{ customer.qq_number }}</span>
                <span
                  v-else
                  class="color-grey"
                >未填写</span>
              </span>
            </div>
            <div class="contact-line">
              <span class="contact-item contact-label">兴趣爱好</span>
              <span class="contact-item contact-gap">:</span>
              <span class="contact-item contact-value">
                <span
                  v-for="i in customer.interests"
                  :key="i.id"
                  style="margin-right: 5px"
                >{{ i.name }}</span>
                <span
                  v-if="!customer.interests.length"
                  class="color-grey"
                >未填写</span>
              </span>
            </div>
            <div class="contact-line">
              <span class="contact-item contact-label">个人主页</span>
              <span class="contact-item contact-gap">:</span>
              <span class="contact-item contact-value">
                <a
                  v-for="hp in customer.home_pages"
                  :key="hp.id"
                  style="margin-right: 5px"
                  :href="hp.page_url"
                  target="_blank"
                >{{ hp.name }}</a>
                <span
                  v-if="!customer.home_pages.length"
                  class="color-grey"
                >未填写</span>
              </span>
            </div>
          </div>
        </Poptip>
        <!-- <span
          v-if="customer.customer_tag&&customer.customer_tag.tag_name"
          class="customer-tag"
        >{{ customer.customer_tag.tag_name }}</span> -->
      </div>
      <div
        class="custoemr-intro"
        :class="[intro_expand ? 'custoemr-intro-expaned' : 'custoemr-intro-folded']"
        @click="toggleExpand()"
      >
        <div ref="intro">
          {{ customer.intro }}
        </div>
      </div>
      <div
        v-if="is_long_intro"
        class="expand-tip"
        @click="toggleExpand()"
      >
        <div v-show="intro_expand">
          收起 <Icon type="ios-arrow-up" />
        </div>
        <div v-show="!intro_expand">
          展开全文 <Icon type="ios-arrow-down" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      customer: {
        type: Object
      }
    },
    data() {
      return {
        is_long_intro: false,
        intro_expand: true,
        map_locate_config: {
          show: false,
          fixed: true
        }
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      this.checkIntroHeight();
    },
    methods: {
      checkIntroHeight() {
        const intro_height = this.$refs.intro.offsetHeight;
        console.log(intro_height);
        if (intro_height > 100) {
          this.is_long_intro = true;
        }
        this.intro_expand = false;
      },
      showLocation() {
        this.map_locate_config.show = true;
      },
      toggleExpand() {
        this.intro_expand = !this.intro_expand;
      }
    }
  }
</script>
